module.exports = __webpack_public_path__ + "b49f56ca8503884f16efd77cde42457b.svg";